module.exports = __webpack_public_path__ + "img/edeka.2c2c3099.png";